import { render } from "./connection-whatsapp.vue?vue&type=template&id=64a2519e&scoped=true"
import script from "./connection-whatsapp.vue?vue&type=script&lang=js"
export * from "./connection-whatsapp.vue?vue&type=script&lang=js"

import "./connection-whatsapp.vue?vue&type=style&index=0&id=64a2519e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a2519e"]])

export default __exports__